/* 我的-钱包-体现 */
<template>
  <div class="reflect-box">
    <!-- 头部 -->
    <headerTop title="提现">
      <span slot="left">
        <div class="return">
          <span class="iconfont iconfanhui"></span>
        </div>
      </span>
    </headerTop>
    <div class="content">
      <!-- 余额 -->
      <div class="step-box">
        <div class="step">
          <div></div>
          <div @click="toReflectRecord">
            <span>提现记录</span>
            <span class="iconfont iconyoujiantou"></span>
          </div>
        </div>
      </div>
      <!-- 提现 -->
      <div class="balance">
        <p>可用余额</p>
        <p>
          <span>¥</span>
          <span>{{ account.withdrawBalance }}</span>
        </p>
      </div>
      <div class="amount-money">
        <div class="title">
          <span>提现金额</span>
          <span>（仅支持整百金额提现）</span>
        </div>
        <div class="money-number">
          <span>¥</span>
          <input
            v-model="price"
            type="text"
            placeholder=""
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
            @blur="formatMoney"
          >
        </div>
      </div>
      <!-- 信息 -->
      <div class="information" v-if="accountDetail.bank_card_id">
        <div class="title">到账银行卡及身份信息</div>
        <div class="information-item">
          <span>卡号</span>
          <span>{{ accountDetail.bank_card_id }}</span>
        </div>
        <div class="information-item">
          <span>姓名</span>
          <span>{{ accountDetail.bank_card_owner }}</span>
        </div>
        <div class="information-item information-item-code">
          <span>身份证</span>
          <span>{{ accountDetail.owner_id_card }}</span>
        </div>
      </div>
    </div>
    <div class="foot-btn">
      <div class="btn" @click="handleSubmit" v-if="accountDetail.bank_card_id">确定</div>
      <div class="btn" @click="toBindingCard" v-if="!accountDetail.bank_card_id">绑定银行卡</div>
    </div>
    <!-- 确认提现 -->
    <van-popup
      class="van-popup"
      v-model="confirmShow"
      close-icon-position="top-right"
      :closeable="false"
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '60%' }"
    >
      <div class="popup-com">
        <div class="popup-header">
          <div class="popup-header-left"></div>
          <div class="popup-header-middle">请确认提现</div>
          <div class="popup-header-right">
            <i class="iconfont iconguanbi" @click="() => {confirmShow = false}"></i>
          </div>
        </div>
        <div class="popup-body popup-pay-stock">
          <div class="popup-pay-stock-text">
            <div class="confirm-box">
              <h2>余额提现</h2>
              <div class="price">
                <span>￥</span>
                {{reflectInfo ? (reflectInfo.price * 0.01).toFixed(2) : ''}}
              </div>
              <div class="line"></div>
              <div class="row">
                <label>提现手续费</label>
                <span>￥{{reflectInfo ? (reflectInfo.service_price* 0.01).toFixed(2) : ''}}</span>
              </div>
              <div class="row">
                <label>提现费率</label>
                <span>{{reflectInfo ? (reflectInfo.withdraw_rate * 0.01).toFixed(2) : ''}}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-footer com-btn-contanier">
          <div class="btn" @click="handleConfirm">确认提现</div>
        </div>
      </div>
    </van-popup>
    <!-- 遮罩 -->
    <div v-show="overlayShow" class="overlay-box">
      <div class="overlay"></div>
      <!-- 支付 -->
      <div v-if="paymentShow" class="payment">
        <!-- 密码输入框 -->
        <div class="payment-input">
          <div class="close" @click="handleClose">
            <span class="iconfont iconguanbi"></span>
          </div>
          <div class="payment-title">请输入支付密码</div>
          <van-password-input :value="value" :focused="showKeyboard" @focus="showKeyboard = true"/>
        </div>
        <van-number-keyboard
          :show="showKeyboard"
          length="6"
          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = true"
        />
        <!-- 数字键盘 -->
      </div>
      <!-- 支付错误 -->
      <div v-if="errorShow" class="Payment-error">
        <div class="title">{{ subMsg }}</div>
        <div v-if="errorAll" class="btn-box">
          <div class="btn-box-l" @click="toNewsInspect">忘记密码</div>
          <div class="btn-box-r" @click="retry">重试</div>
        </div>
        <div v-else class="btn-box">
          <div class="btn-box-c" @click="toNewsInspect">忘记密码</div>
        </div>
      </div>
    </div>
    <!-- 提示 -->
    <div v-show="show">
      <remind title="已收到您的提现申请"></remind>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import remind from "@/components/common/remind.vue";
import javaApi from "@/api/javaApi";
import accountApi from "@/api/accountApi";

export default {
  data() {
    return {
      value: "",
      confirmShow: false, // 确认提现
      reflectInfo: null, // 提现金额信息
      showKeyboard: false, // 密码输入框显示
      overlayShow: false, // 遮罩显示
      paymentShow: true, // 密码输入框
      errorShow: false, // 密码错误提示
      show: false, // 控制提示
      accountDetail: {},
      subMsg: "",
      withdrawBillCount: "", //当日提现次数
      account: {},
      price: "",
      errorAll: true
    };
  },
  methods: {
    formatMoney() {
      if (this.price === "" || Number(this.price) === 0) {
        this.price = "";
        this.$toast({
          message: "请输入提现金额",
          duration: 1500
        });
      } else if (
        parseInt(this.account.withdrawBalance) < parseInt(this.price)
      ) {
        const price = this.account.withdrawBalance;
        // 向下取整
        this.price = Math.floor(price / 100) * 100;
        this.$toast({
          message: "提现金额不能大于可提现金额",
          duration: 1500
        });
      }
    },
    handleSubmit() {
      if (this.price === "" || Number(this.price) <= 0) {
        this.price = "";
        this.$toast({
          message: "请输入提现金额",
          duration: 1500
        });
      } else if (this.withdrawBillCount > 0) {
        this.$toast({
          message: "每天只能提现一次，请明天再试",
          duration: 1500
        });
      } else if (parseInt(this.balanceNumber) < parseInt(this.price)) {
        this.$toast({
          message: "提现金额不能大于可提现金额",
          duration: 1500
        });
      } else if (this.price % 100) {
        this.$toast({
          message: "提现金额必须是100的整数倍",
          duration: 1500
        });
      } else {
        // 获得用户提现金额信息
        javaApi
          .calcuWithDraw({
            price: this.price
          })
          .then(res => {
            this.reflectInfo = res;
            this.confirmShow = true;
          });
      }
    },
    async handleConfirm() {
      this.confirmShow = false;
      if (this.price === "" || Number(this.price) <= 0) {
        this.price = "";
        this.$toast({
          message: "请输入提现金额",
          duration: 1500
        });
      } else if (this.withdrawBillCount > 0) {
        this.$toast({
          message: "每天只能提现一次，请明天再试",
          duration: 1500
        });
      } else if (
        parseInt(this.account.withdrawBalance) < parseInt(this.price)
      ) {
        this.$toast({
          message: "提现金额不能大于可提现金额",
          duration: 1500
        });
      } else if (this.price % 100) {
        this.$toast({
          message: "提现金额必须是100的整数倍",
          duration: 1500
        });
      } else {
        // 判断是否设置支付密码
        let res = await accountApi.tradePasswordCheck();
        if (res.status == 1) {
          // 打开遮罩
          this.overlayShow = true;
          // 打开支付
          this.paymentShow = true;
        } else {
          // 跳转到设置支付密码页面
          this.$router.push({
            name: "newsInspect"
          });
        }
      }
    },
    handleClose() {
      this.overlayShow = false;
    },
    onInput(key) {
      this.value = (this.value + key).slice(0, 6);
      if (this.value.length >= 6) {
        // 先关闭支付控件
        this.paymentShow = false;
        // 提现
        let data = {
          price: this.reflectInfo ? this.reflectInfo.price : undefined,
          service_price: this.reflectInfo
            ? this.reflectInfo.service_price
            : undefined,
          real_price: this.reflectInfo
            ? this.reflectInfo.real_price
            : undefined,
          withdraw_rate: this.reflectInfo
            ? this.reflectInfo.withdraw_rate
            : undefined,
          password: this.value,
          account_bank_id: this.accountDetail.id
        };
        javaApi
          .payWithdraw124(data)
          .then(res => {
            console.log("成功", res);
            this.toTip(res);
          })
          .catch(res => {
            console.log("失败", res);
            // 2026-10-17：原来传 res.data，而 toTip 读的是 res.subCode ⇒ undefined，
            // 结果弹出内容空白的提示框。拦截器 reject 出来的是完整响应，直接传 res。
            this.toTip(res);
          });
      }
    },
    toTip(res) {
      if (Number(res.subCode) != 200) {
        this.value = "";
        this.paymentShow = false;
        this.subMsg = res.subMsg;
        if (Number(res.subCode) === 4000) {
          this.errorShow = true;
          // data 可能为 null / ""（项目 Jackson 把 null 序列化成 ""），做兜底避免报错
          const pwd = (res.data && res.data.password) || {};
          const usable = pwd.usable_number;
          this.errorAll = usable != 0;
          if (usable == 0) {
            this.subMsg = "密码错误次数已达上限，请重置密码";
          }
        } else {
          // 拦截器已按 subCode 弹过同一条 subMsg，这里不再重复 toast，只收起键盘
          this.handleClose();
        }
      } else {
        this.show = true;
      }
    },
    onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    },
    // 重试
    retry() {
      this.errorShow = false;
      this.paymentShow = true;
    },
    toReflectRecord() {
      this.$router.push({
        name: "reflectRecord"
      });
    },
    toNewsInspect() {
      this.$router.push({
        name: "newsInspect"
      });
    },
    toBindingCard() {
      this.$router.push({
        name: "bindingCard"
      });
    }
  },
  components: {
    headerTop,
    remind
  },
  async mounted() {
    this.account = await javaApi.accountDetail();
    this.withdrawBillCount = this.account.withdrawBillCount;
    if (this.$store.state.accountBank.id === undefined) {
      // this.$router.push({
      //     name: 'bindingCard'
      // });
    } else {
      this.accountDetail = this.$store.state.accountBank;
    }
  }
};
</script>

<style lang="less" >
.reflect-box {
  .content {
    padding: 20px 0;
    .step-box {
      padding: 0 30px;
      .step {
        display: flex;
        justify-content: space-between;
        & div:nth-child(1) {
          font-size: 14px;
          color: #333333;
        }
        & div:nth-child(2) {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
          .iconyoujiantou {
            margin-left: 5px;
            font-size: 12px;
          }
        }
      }
    }
    .balance {
      margin-top: 8px;
      padding: 0 24px;
      overflow: hidden;
      & p:nth-child(1) {
        font-size: 16px;
        color: #333333;
      }
      & p:nth-child(2) {
        margin-top: 10px;
        font-size: 20px;
        color: #1d1d1d;
      }
    }
    .amount-money {
      padding: 0 24px;
      margin-top: 25px;
      .title {
        & span:nth-child(1) {
          font-size: 16px;
          color: #333333;
        }
        & span:nth-child(2) {
          font-size: 12px;
          color: #999999;
          margin-left: 5px;
        }
      }
      .money-number {
        margin-top: 5px;
        display: flex;
        height: 50px;
        width: 100%;
        border-bottom: 1px solid #e4e4e4;
        position: relative;
        span {
          font-size: 16px;
          color: #1d1d1d;
          position: absolute;
          bottom: 4px;
        }
        input {
          width: 100%;
          height: 100%;
          font-size: 36px;
          color: #000000;
          padding-left: 10px;
          background-color: #ffffff;
        }
      }
    }
    .information {
      padding: 0 26px;
      margin-top: 20px;
      .title {
        font-size: 14px;
        color: #999999;
      }
      & .information-item:nth-child(1) {
        margin-top: 5px;
      }
      .information-item-code {
        & span:nth-child(2) {
          margin-left: 17px !important;
        }
      }
      .information-item {
        height: 50px;
        width: 100%;
        border-bottom: 1px solid #e4e4e4;
        line-height: 50px;
        font-size: 14px;
        color: #999999;
        & span:nth-child(2) {
          margin-left: 31px;
        }
      }
    }
  }
  .foot-btn {
    padding: 0 15px;
    margin-top: 11px;
    .btn {
      width: 100%;
      height: 45px;
      background: #8a3e2f;
      color: #f8f8f8;
      font-size: 18px;
      line-height: 45px;
      text-align: center;
    }
  }
  .confirm-box {
    text-align: center;
    padding-top: 20px;
    h2 {
      font-size: 16px;
      color: #333333;
      line-height: 1.5;
      margin-bottom: 10px;
    }
    .price {
      font-size: 26px;
      color: #151515;
      line-height: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .line {
      border-bottom: 0.5px solid #e4e4e4;
    }
    .row {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      label {
        font-size: 14px;
        color: #666666;
      }

      span {
        font-size: 14px;
        color: #333333;
      }
    }
  }
  .overlay-box {
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all ease-out;
    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .payment {
      .payment-input {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 325px;
        height: 160px;
        background: #ffffff;
        border-radius: 6px;
        .close {
          position: absolute;
          right: 17px;
          top: 17px;
          span {
            color: #b2b2b2;
            font-size: 14px;
          }
        }
        .payment-title {
          font-size: 16px;
          color: #333333;
          text-align: center;
          margin-top: 26px;
        }
        .van-password-input {
          margin-top: 26px;
          li {
          }
        }
      }
    }
    .Payment-error {
      background: #ffffff;
      border-radius: 6px;
      width: 325px;
      height: 158px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .title {
        font-size: 16px;
        color: #333333;
        text-align: center;
        margin-top: 26px;
      }
      .btn-box {
        display: flex;
        margin-top: 34px;
        .btn-box-l {
          background: #ededed;
          width: 115px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          color: #1d1d1d;
          margin-left: 37px;
          margin-right: 28px;
        }
        .btn-box-c {
          background: #ededed;
          width: 100%;
          height: 44px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          color: #1d1d1d;
          margin-left: 37px;
          margin-right: 28px;
        }
        .btn-box-r {
          background: #8a3e2f;
          width: 115px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
